// The Mars Med Supply wordmark (public/brand/mars-logo.png, 300 x 48, the
// colour version the store publishes, on an opaque white background). On a
// light surface it sits as is; on the dark sidebar and in dark mode it sits
// on a small white tile so the real logo shows instead of a white block.
// Size comes from the caller's classes (one of width or height); the ratio
// keeps the other.

const SRC = "/brand/mars-logo.png";

export function BrandLogo({
  variant = "color",
  className = "",
  tileClassName = "",
}: {
  /** "tile" puts the logo on a white rounded tile for dark backgrounds. */
  variant?: "color" | "tile";
  className?: string;
  tileClassName?: string;
}) {
  const img = <img src={SRC} alt="Mars Med Supply" className={className} style={{ aspectRatio: "300 / 48" }} />;
  if (variant === "color") return img;
  return <span className={`inline-flex items-center rounded-lg bg-white ${tileClassName || "px-3 py-2"}`}>{img}</span>;
}
